import * as types from '@store/types'
import request from '@queries'
import LettersQuery from '@queries/Letters'
import LetterQuery from '@queries/Letter'
import DeleteLetter from '@queries/DeleteLetter'
import axios from 'axios'

const state = {
  letters: {},
  letter: [],
  paginate: {
    to: 0,
    from: 0,
    total: 0,
    per_page: 9,
    current_page: 1
  }
}

const getters = {
  [types.LETTERS]: ({ letters }) => letters,
  [types.LETTER]: ({ letter }) => letter,
  [types.LETTERS_PAGINATE]: ({ paginate }) => paginate,
  [types.LETTERS_TOTAL]: ({ paginate: { total } }) => +total
}

const mutations = {
  [types.LETTERS]: (state, payload) => {
    state.letters = payload
  },

  [types.LETTER]: (state, payload) => {
    state.letter = payload
  },

  [types.LETTERS_PAGINATE]: (state, payload) => {
    state.paginate = payload
  },

  [types.LETTER_EXCLUDE]: (state, id) => {
    state.letters = state.letters.filter(letter => letter.id !== id)
  }
}

const actions = {
  [types.LETTERS]: async ({ commit }, payload) => {
    const response = await request(LettersQuery, { ...payload })
    const { data: letters, ...paginate } = response.data.data.letters || {}
    commit(types.LETTERS, letters)
    commit(types.LETTERS_PAGINATE, paginate)
  },

  [types.LETTER]: async ({ commit }, id) => {
    const response = await request(LetterQuery, { id })
    const letter = response.data.data.letter || {}
    commit(types.LETTER, letter)
  },

  [types.LETTERS_INCREASE]: async ({ commit, getters }) => {
    const {
      to,
      from,
      total,
      per_page: limit,
      current_page: current
    } = getters[types.LETTERS_PAGINATE] || {}

    const isValid = total > (from + limit - 1)

    if (!isValid)
      return

    const { company } = getters[types.AUTH] || {}
    const response = await request(LettersQuery, { company, page: current + 1 })

    const { data, ...paginate } = response.data.data.letters || {}
    const letters = [ ...getters[types.LETTERS], ...data ]

    commit(types.LETTERS, letters)
    commit(types.LETTERS_PAGINATE, paginate)
  },

  [types.LETTER_EXCLUDE]: async ({ commit, dispatch }, id) => {
    const payload = { id }

    const { status } = await request(DeleteLetter, payload)

    if (status) {
      const message = { type: 'success', text: 'Carta deletada com sucesso!' }

      dispatch(types.FEEDBACK, message)
      commit(types.LETTER_EXCLUDE, id)
    } else {
      const message = { type: 'error', text: 'Houve um erro ao deletar a Carta!' }
      dispatch(types.FEEDBACK, message)
    }
  },

  [types.LETTER_SEND_EMAIL]: async ({}, payload) => {
    const path = `rescue/letter/${payload.letterId}`
    const response = await axios.post(path, { email: payload.email })

    return response.data.success
  },

  [types.LETTER_VALIDATE_EMAIL]: async ({}, payload) => {
    const path = `user/check-email`

    try {
      const response = await axios.post(path, { email: payload })

      return response.status
    } catch (err) {
      return err.response.status
    }
  },
}

export default { state, getters, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/letter.js